module.exports = __webpack_public_path__ + "static/media/Close-eye.85957fbe.svg";